export default __webpack_public_path__ + "static/media/candidateAwaiting.d97faf05.mp3";